document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.info-slider');

  if (!slider) return;

  // Function to hide all tooltips
  const hideAllTooltips = () => {
    const tooltips = slider.querySelectorAll('.tooltip');
    tooltips.forEach(tooltip => {
      tooltip.style.display = 'none';
      tooltip.style.visibility = 'hidden';
      tooltip.style.opacity = '0';
    });
  };

  // Function to show a specific tooltip
  const showTooltip = (item) => {
    const tooltip = item.querySelector('.tooltip');
    if (tooltip) {
      tooltip.style.display = 'block';
      tooltip.style.visibility = 'visible';
      tooltip.style.opacity = '1';
    }
  };

  // Mouseenter event (hover in) for desktop
  slider.addEventListener('mouseenter', (e) => {
    const item = e.target.closest('.info-item');
    if (item) {
      hideAllTooltips();
      showTooltip(item);
    }
  }, true);

  // Mouseleave event (hover out) for desktop
  slider.addEventListener('mouseleave', (e) => {
    const item = e.target.closest('.info-item');
    if (item && (!e.relatedTarget || !e.relatedTarget.closest('.info-slider'))) {
      hideAllTooltips();
    }
  }, true);

  // Touch support for mobile (if needed, but bar is hidden on mobile)
  slider.addEventListener('touchstart', (e) => {
    const item = e.target.closest('.info-item');
    if (item) {
      e.preventDefault();
      hideAllTooltips();
      showTooltip(item);
    }
  }, { passive: false });

  slider.addEventListener('touchend', () => {
    hideAllTooltips();
  }, { passive: false });

  // Keyboard accessibility
  slider.addEventListener('focusin', (e) => {
    const item = e.target.closest('.info-item');
    if (item) {
      hideAllTooltips();
      showTooltip(item);
    }
  });

  slider.addEventListener('focusout', (e) => {
    const item = e.target.closest('.info-item');
    if (item && (!e.relatedTarget || !e.relatedTarget.closest('.info-slider'))) {
      hideAllTooltips();
    }
  });
});